// ViewerFooter.tsx
import React, { useState, useCallback, useEffect } from 'react';
import { Toolbar } from '../Toolbar/Toolbar';
import SidePanelWithServices from '../Components/SidePanelWithServices';

function ViewerFooter({ servicesManager }) {
  const [isMobile, setIsMobile] = useState(false);
  const [seriesOpen, setSeriesOpen] = useState(true); // Valor inicial temporal

  useEffect(() => {
    const checkIfMobile = () => {
      const isMobileDevice = /(Mobi|Android|iPhone|iPad|iPod)/.test(navigator.userAgent);
      setIsMobile(isMobileDevice);
      // Solo establecemos el estado inicial aquí
      setSeriesOpen(!isMobileDevice);
    };

    checkIfMobile();
    // Eliminamos el event listener ya que solo nos interesa el estado inicial
  }, []); // Array de dependencias vacío para que solo se ejecute una vez

  const updateSeriesOpen = useCallback(open => {
    setSeriesOpen(open);
  }, []);

  return (
    <div className="align-items-center relative flex justify-center gap-[0px]">
      {/* Panel Lateral */}
      <SidePanelWithServices
        side="left"
        activeTabIndex={0}
        servicesManager={servicesManager}
        expandedWidth={300}
        panelOpen={seriesOpen}
      />
      {/* Toolbar con botones para controlar el panel */}
      <Toolbar
        servicesManager={servicesManager}
        updateSeriesOpen={updateSeriesOpen}
        seriesOpen={seriesOpen}
      />
    </div>
  );
}

export default ViewerFooter;
